// Shared presentation copy only; Radio, notifications and wallet policy own availability.
export const artistOpportunityCopy = Object.freeze({
  introduction:
    'Release announcements from @thejoegalaxy help introduce new additions to the connected listener and artist community.',
  discovery:
    'While your record is in rotation, listeners arriving through Listener Pass and exploring JG Universe can discover your music. You’ll also have a song link to share with your own audience.',
  participation:
    'Signed-in listeners can react and give feedback. With artist support enabled, they can also tip or support your music with JGK, the platform token.',
  cashout:
    'Eligible JGK support earnings have USD cash-out value. Request a payout through the JG wallet using supported options, including Venmo.',
  qualification: 'Current minimums and any applicable fees apply.',
  notifications:
    'You can receive account alerts when listeners leave feedback. Push and email availability depend on your settings and delivery eligibility.',
});
